(function () {
    'use strict';

    function CompanySchedulesController($scope, $state, TimingInfo, ScheduleInfoCustom, ScheduleInfoSearch, ScheduleInfo, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $timeout, DialogService, CompanyInfoQuery) {

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.selectedId = '';
        $ctrl.formState = 'list';
        $ctrl.newItem = newItem;
        $ctrl.editItem = editItem;
        $ctrl.backToList = backToList;
        $ctrl.generateTimeInfo = generateTimeInfo;
        $ctrl.showTimingInfo = showTimingInfo;
        $ctrl.backToScheduleInfo = backToScheduleInfo;
        $ctrl.saveSchedule = saveSchedule;
        $ctrl.schSelected = false;
        $ctrl.schSaved = false;
        $ctrl.step = 0;
        $ctrl.isSaving = false;
        $ctrl.schedulerApi = {refresh: 'not set'};
        $ctrl.hasBaseOffDaySchedule = false;
        $ctrl.defaultBaseOffDayScheduleId = null;
        $ctrl.baseOffDayScheduleSwitch_changed = baseOffDayScheduleSwitch_changed;
        $ctrl.showLimitDates = false;
        $ctrl.showLimitDateChange = showLimitDateChange;


        $ctrl.refreshList = function () {

            $ctrl.scheduleInfos = [];

            CompanyInfoQuery.getCurrentCompanyInfo().query(function (comp) {
                if (comp) {
                    ScheduleInfoCustom.primaryScheduleInfosByCompany(comp.id).query(function (schedules) {
                        $ctrl.scheduleInfos = schedules;
                        if ($ctrl.scheduleInfos.length == 0)
                            $ctrl.newItem();
                        else {
                            if (!$ctrl.selectedId) {
                                // $ctrl.editItem($ctrl.scheduleInfos[0]);
                                editItemV2($ctrl.scheduleInfos[0]);
                            }

                        }
                        // checkShowLimitDates();
                    });


                    ScheduleInfoCustom.getDefaultBaseOffDaySchedule().query().$promise.then(function (sch) {
                        if (sch && sch.id)
                            $ctrl.defaultBaseOffDayScheduleId = sch.id;

                    });


                }
            })
        }

        //
        $ctrl.generateTimesUntil = generateTimesUntil;
        $timeout(function () {
            loadAll();
            loadPage();

        });


        function showTimingInfo() {
            $ctrl.timingInfo = $ctrl.selectedScheduleInfo.timingInfo;
            $ctrl.step = 1;
        }

        $ctrl.delete = function (scheduleid) {
            DialogService.showConfirm("آیا از حذف برنامه زمانی مورد نظر اطمینان دارید؟").then(function () {
                ScheduleInfo.delete({id: scheduleid});

            });
        }

        function saveSchedule() {
            $ctrl.selectedScheduleInfo.companyId = $ctrl.companyId;
            $ctrl.isSaving = true;

            if ($ctrl.hasBaseOffDaySchedule && $ctrl.defaultBaseOffDayScheduleId) {
                $ctrl.selectedScheduleInfo.baseOffDayScheduleInfoId = $ctrl.defaultBaseOffDayScheduleId;
            } else {
                $ctrl.selectedScheduleInfo.baseOffDayScheduleInfoId = null;
            }

            TimingInfo.saveScheduleInfoForCompany().save($ctrl.selectedScheduleInfo, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                $ctrl.selectedId = sch.id;
                //  $ctrl.timingInfo = sch.timingInfo;
                $ctrl.step = 1;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;
                $ctrl.isSaving = false;
                //$ctrl.refreshList();
            });
        }

        function generateTimesUntil() {
            var untilDate = new Date();
            TimingInfo.generateTimeSessionsForScheduleUntilDate($ctrl.selectedScheduleInfo.id, untilDate).get();
        }

        function generateTimeInfo() {


            TimingInfo.generateTimingInfo.save($ctrl.selectedScheduleInfo, function (timingInfo) {
                timingInfo.refreshed = true;
                $ctrl.timingInfo = timingInfo;
                $ctrl.selectedScheduleInfo.timingInfo = timingInfo;
            });
            if ($ctrl.schedulerApi.refreshScheduler)
                $ctrl.schedulerApi.refreshScheduler();
        }

        function backToScheduleInfo() {
            $ctrl.step = 0;
        }

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();
            $ctrl.scheduleInfos = [];

            $ctrl.refreshList();
        }

        function newItem() {
            //
            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedScheduleInfo = ScheduleInfo.get({id: -1});
            $ctrl.selectedScheduleInfo.companyId = $ctrl.companyId;
            $ctrl.schSelected = true;
            $ctrl.schSaved = false;
            updateTabs();

        }

        function editItem(id) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = id;
            ScheduleInfo.get({id: id.id}, function (sch) {

                $ctrl.selectedScheduleInfo = sch;
                checkShowLimitDates();

                var now = new Date();
                now.setDate(now.getDate() - 1);
                now.setHours(0);
                now.setMinutes(0);
                now.setSeconds(0);
                var tempArr = [];
                angular.forEach($ctrl.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                    if (new Date(exDate.startDate) > now) {
                        tempArr.push(exDate);
                        // var index = $ctrl.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                        //
                        // $ctrl.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                    }
                })
                $ctrl.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
                $ctrl.schSelected = true;
                $ctrl.schSaved = true;


                if ($ctrl.selectedScheduleInfo && $ctrl.selectedScheduleInfo.baseOffDayScheduleInfo) {
                    $ctrl.hasBaseOffDaySchedule = true;
                }

                updateTabs();
            });

        }

        function editItemV2(sch) {

            $ctrl.formState = 'BASIC_SCHEDULE_INFO';
            $ctrl.selectedId = sch.id;

            $ctrl.selectedScheduleInfo = sch;
            checkShowLimitDates();

            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            angular.forEach($ctrl.selectedScheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                    // var index = $ctrl.selectedScheduleInfo.scheduleExceptionDurations.indexOf(exDate);
                    //
                    // $ctrl.selectedScheduleInfo.scheduleExceptionDurations.splice(index, 1);
                }
            })
            $ctrl.selectedScheduleInfo.scheduleExceptionDurations = tempArr;
            $ctrl.schSelected = true;
            $ctrl.schSaved = true;


            if ($ctrl.selectedScheduleInfo && $ctrl.selectedScheduleInfo.baseOffDayScheduleInfo) {
                $ctrl.hasBaseOffDaySchedule = true;
            }

            updateTabs();


        }

        function updateTabs() {
            if ($ctrl.formState == 'BASIC_SCHEDULE_INFO') {

                $('#schedtabs a[data-target="#menu1"]').tab('show');
            }
        }


        function backToList() {

            $ctrl.formState = 'list';
            $ctrl.selectedScheduleId = '';
            $ctrl.refreshList();
        }

        function baseOffDayScheduleSwitch_changed() {


        }

        function showLimitDateChange() {
            if (!$ctrl.showLimitDates) {
                $ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate = null;
                $ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {

            if ($ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.toDate) {
                $ctrl.showLimitDates = true;
                return;
            }

            if ($ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate) {

                var date = new Date();
                var fromDate = new Date($ctrl.selectedScheduleInfo.weeklyScheduleInfo.datePeriod.fromDate);
                if (fromDate > date)
                    $ctrl.showLimitDates = true;
            }

        }


    }

    var CompanySchedules = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/company-schedules/partial-form.company-schedules.html',
        controller: CompanySchedulesController,
        bindings: {
            companyId: '<',
            selectedScheduleInfo: '='
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('pfCompanySchedules', CompanySchedules)

    //  CompanySchedulesController.$inject = ['$scope','$attrs','$element'];
    CompanySchedulesController.$inject = ['$scope', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ScheduleInfoSearch', 'ScheduleInfo', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$timeout', 'DialogService', 'CompanyInfoQuery'];


})();

